import { CSSObject } from '@emotion/react'
import { Color, Spacing } from '@opallabs/gem'
import { getComponentClassName } from './classNames'
import type { StyleProps } from './types'

export const listStyles: CSSObject = {
  marginBlockEnd: Spacing.S * 1.25,
  padding: 0,
}

export const tabStyles: CSSObject = {
  display: 'inline-block',
  cursor: 'pointer',
  listStyle: 'none',
  outline: 'none',

  // set `backgroundColor` on `::before` for hover/active states
  '&::before': {
    content: '""',
    display: 'flex',
    inset: 0,
    position: 'absolute',
    zIndex: 1,
  },

  '&:not(:first-of-type)': {
    marginInlineStart: Spacing.XS * 1.25,
  },
  '&:not(:last-of-type)': {
    marginInlineEnd: Spacing.XS * 1.25,
  },
}

export const tabContentStyles: CSSObject = {
  position: 'relative',
  zIndex: 2,
}

const panelClass = `.${getComponentClassName('panel')}`

export const panelStyles = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor: Color[theme].Surface.N000,
  display: 'none',
})

const selectedPanelClass = `${panelClass}--selected`

export const tabsStyles: CSSObject = {
  [selectedPanelClass]: {
    display: 'block',
  },
}
